import logo from "../../../resources/Color variable-07.png";

const Footer = ({ scrollToSection }) => {
  return (
    <footer className="bg-slate-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <img src={logo} className="object-contain md:h-12 h-9 w-auto" />
            <p className="text-slate-400 text-sm">
              La plataforma todo-en-uno para consultorios odontológicos
              modernos.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Producto</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>
                <button onClick={() => scrollToSection("features")}>
                  Características
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("pricing")}>
                  Precios
                </button>
              </li>
              <li>
                <a href="/registrarse">Registrarse</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Soporte</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>
                <button
                  onClick={() =>
                    window.open("https://wa.me/4917670568851", "_blank")
                  }
                >
                  Atención al cliente
                </button>
              </li>
              <li>
                <a href="/politica-de-privacidad">Política de privacidad</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Síguenos</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61558801250923"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/odontostark/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center text-slate-400 text-sm">
          © 2025 OdontoStark. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
